import Link from 'next/link';

import { formatDate, getBlogLinkUrl } from '@/helpers/helpers';

import ArticlesReadMoreTrigger from '@/components/ArticlesReadMoreTrigger';

import * as styles from './index.module.scss';

const ArticlesCards = ({ articles = {}, headline = 'More Articles' }) => {
  return (
    <div className={`${styles['articles-cards-container']}`}>
      <div className={`container ${styles['container']}`}>
        <h2>{headline}</h2>
        <div className={styles['articles-wrapper']}>
          {articles.map((article) => (
            <Link href={getBlogLinkUrl(article)} key={article.id} className={styles['article-card']}>
              <div className={styles['attribution-container']}>
                <span className={styles['author']}>{article.author}</span>
                <span className={styles['category']}>{article.category_name}</span>
                <span className={styles['date']}>{formatDate(article.date_published)}</span>
              </div>
              <h3 dangerouslySetInnerHTML={{ __html: article.h1 }} />
              <p dangerouslySetInnerHTML={{ __html: article.blurb }} />
              <ArticlesReadMoreTrigger />
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ArticlesCards;
